/**
 * @generated SignedSource<<b84aed380b0764d13d6644207cc8de3d>>
 * @relayHash 44d26cb8c2be158cbd259a7f2611217d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1fae9ece2287d85ec26139ef994bbe298fb53a21bf28bdfcae2767fc4518ec70

import type { ConcreteRequest } from 'relay-runtime';
export type useContentLabelsDetailsPanelContentLabelDeleteMutation$variables = {
  contentId: string;
  label: string;
};
export type useContentLabelsDetailsPanelContentLabelDeleteMutation$data = {
  readonly deleteLabel: {
    readonly contentId: string;
  } | null;
};
export type useContentLabelsDetailsPanelContentLabelDeleteMutation = {
  response: useContentLabelsDetailsPanelContentLabelDeleteMutation$data;
  variables: useContentLabelsDetailsPanelContentLabelDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "label"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "label",
            "variableName": "label"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "DeleteLabelPayload",
    "kind": "LinkedField",
    "name": "deleteLabel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contentId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContentLabelsDetailsPanelContentLabelDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContentLabelsDetailsPanelContentLabelDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "44d26cb8c2be158cbd259a7f2611217d",
    "id": "1fae9ece2287d85ec26139ef994bbe298fb53a21bf28bdfcae2767fc4518ec70",
    "metadata": {},
    "name": "useContentLabelsDetailsPanelContentLabelDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation useContentLabelsDetailsPanelContentLabelDeleteMutation($contentId:ID!,$label:String!){deleteLabel(input:{contentId:$contentId,label:$label}){contentId}}"
  }
};
})();

(node as any).hash = "12edf2776def05e962614a8adfefefcb";

export default node;
